import { render } from "./MavaneKhoroj.vue?vue&type=template&id=5986b27f&scoped=true"
import script from "./MavaneKhoroj.vue?vue&type=script&lang=js"
export * from "./MavaneKhoroj.vue?vue&type=script&lang=js"

import "./MavaneKhoroj.vue?vue&type=style&index=0&id=5986b27f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5986b27f"]])

export default __exports__